<template>
    <!--    <div style="height: 100%; overflow: auto"> -->
    <b-modal scrollable b-modal ref="mdlConfigurazionePostiLettoLetti" id="mdlConfigurazionePostiLettoLetti" size="lg" style="height: 100%" title="LETTO" no-close-on-backdrop no-close-on-esc hide-header-close centered>
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <label class="sa-label-data">Nome</label>
                <b-form-input v-model="jsonData.nome"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <label class="sa-label-data">Tipo Letto</label>
                <b-form-select v-model="jsonData.tipoLetto" class="mb-2 mr-sm-2 mb-sm-0" :options="tipoLettoOptions" :value="null" value-field="value" text-field="text">
                    <template #first>
                        <b-form-select-option :value="null" disabled> - Seleziona Letto - </b-form-select-option>
                    </template>
                </b-form-select>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <label class="sa-label-data">Stato</label>
                <b-form-select v-model="jsonData.statoAttuale" :disabled="isDisabled" class="mb-2 mr-sm-2 mb-sm-0" :options="statoAttualeOptions" :value="null" value-field="stato" text-field="descrizione"></b-form-select>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label class="sa-label-data">Note</label>
                <b-form-textarea v-model="jsonData.note" rows="5"></b-form-textarea>
            </b-col>
        </b-row>
        <template #modal-footer>
            <b-button @click="closeModal" variant="outline-danger" size="md">Annulla </b-button>
            <b-button @click="onOkConfigurazioneLetti" variant="outline-success" size="md">Salva</b-button>
        </template>

        <modal-error ref="cmpModalError"></modal-error>
    </b-modal>
    <!-- </div> -->
</template>

<script>
import axios from "axios";
import UtilityMixin from "../../../utility/UtilityMixin";
import ModalError from "../../../../template/components/modal/components/ModalError.vue";
export default {
    components: { ModalError },
    mixins: [UtilityMixin],
    data() {
        return {
            isDisabled: true,
            pathResource: "/rsapostilettoletti",
            idStanza: null,
            pathResourceStatoLetti: "/rsapostilettolettostati",
            jsonData: {
                idAccettazione: null,
                idStanza: null,
                nome: "",
                tipoLetto: null,
                statoAttuale: null,
                note: "",
                statoAttualeDataOra: new Date().getTime(),
            },
            tipoLettoOptions: [
                { value: "Normale", text: "Normale" },
                { value: "Elettrico", text: "Elettrico" },
            ],
            statoAttualeOptions: [],
            id: null,
        };
    },
    watch: {
        // jsonData: {
        //     handler(jsonData) {
        //         this.$emit("update", jsonData);
        //     },
        //     deep: true,
        // },
    },
    mounted() {
        let me = this;
        me.idStanza = me.$route.params.id;
        // console.log("idStanza preso nel mounted: ", me.idStanza);

        me.loadStatoAttuale();
    },
    methods: {
        show() {
            let me = this;
            // console.log("idStanza nel show", me.idStanza);
            me.jsonData.idStanza = me.idStanza;
            me.$refs.mdlConfigurazionePostiLettoLetti.show();
        },
        showConfigurazioneLettoEdit(id) {
            let me = this;
            me.id = id;
            me.loadData();
            me.$refs.mdlConfigurazionePostiLettoLetti.show();
        },
        /* onShowConfigurazioneLetto() {
            let me = this;
            if (!me.id) {
                me.jsonData = { idStanza: me.idStanza, nome: "", tipoLetto: null, statoAttuale: "DISPONIBILE", note: "", statoAttualeDataOra: new Date().getTime() };
            }
            me.loadStatoAttuale();
        }, */
        loadStatoAttuale() {
            let me = this;
            me.loadDataResources(me.pathResourceStatoLetti, {}, me.resulResponseStatoLetti, me.resultErrorStatoLetti);
        },
        resulResponseStatoLetti(response) {
            let me = this;
            me.statoAttualeOptions = response.data.data.list;
            me.statoAttualeOptions.unshift({ stato: null, descrizione: "- Selezionare Stato -" });
        },
        resultErrorStatoLetti(error) {
            console.log(error);
        },

        loadData() {
            this.$emit("beforeLoadData");
            let me = this;
            if (me.id === "-1") {
                this.$emit("afterLoadData");
            } else {
                // me.showModalLoading = true;
                let link = process.env.VUE_APP_PATH_API + me.pathResource + "/" + me.id;
                axios.get(link).then((response) => {
                    me.jsonData = response.data.data;

                    this.$emit("afterLoadData");
                });
            }
        },
        salvaLetto() {
            let me = this;
            UtilityMixin.methods.saveResource(me.pathResource, me.jsonData, me.resultSaveSuccess, me.resultSaveError);
            // console.log("Json da salvare: ", me.jsonData);
        },
        resultSaveSuccess() {
            let me = this;
            me.$emit("saveResponse");
            me.closeModal();
        },
        resultSaveError(error) {
            let me = this;
            me.$refs.cmpModalError.show(error.response.data.messaggio);
        },
        onOkConfigurazioneLetti() {
            let me = this;
            me.salvaLetto();
            // bvModalEvent.preventDefault();
        },
        onHidden() {},
        closeModal() {
            let me = this;
            me.jsonData = {
                idAccettazione: null,
                idStanza: this.idStanza,
                nome: null,
                tipoLetto: null,
                statoAttuale: null,
                note: null,
                statoAttualeDataOra: new Date().getTime(),
            };
            me.$refs.mdlConfigurazionePostiLettoLetti.hide();
        },
    },
};
</script>

<style></style>
